import { MenuItem, styled } from '@mui/material'

export const StyledMenuItem = styled(MenuItem)(({ theme }) => ({
  display: 'flex',
  gap: 32,
  height: 40,
  margin: '8px 0',
  color: theme.palette.grey[700],
}))
